// @core/api/endpoints/audittrail/list_audit_records_by_resource.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListAuditRecordsResponse,
} from '../../../types/audittrail';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/audittrail';

/**
 * List audit records by resource
 * Returns all audit records related to a specific resource, identified by its URN.
 */
export async function ListAuditRecordsByResource(
  resource_urn: string,
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListAuditRecordsResponse> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/audit/resources/:resource_urn/records`;
  requestPath = requestPath.replace(':resource_urn', encodeURIComponent(resource_urn));
  const requestOptions = options;
  return client.get<ListAuditRecordsResponse>(requestPath, { ...requestOptions, params });
}
